import { warn as emberWarn } from '@ember/debug';

/**
 * Indirection around `@ember/debug` helpers.
 *
 * Under the Embroider/webpack ESM build the `@ember/debug` namespace exports are
 * non-configurable, so they cannot be stubbed directly (e.g. `sinon.stub(EmberDebug, 'warn')`
 * throws "Descriptor for property warn is non-configurable and non-writable"). Calling
 * through this plain object lets tests stub `Debug.warn` while preserving the exact
 * `warn(message, condition, options)` signature in source.
 */
export const Debug = {
  warn(...args) {
    return emberWarn(...args);
  },
};

export default Debug;
